<template>
  <div>
    <headerTop></headerTop>
    <el-row style="background: #f6f6f8" class="notice">
      <el-row>
        <el-input size="medium" v-model="search.findSourceCode" placeholder="输入寻源询价单号查询" plain
          style="width: 200px"></el-input>
        <el-button type="success" @click="searchKey()" icon="el-icon-search">搜索</el-button>
        <el-link type="primary" style="margin: 10px 20px 10px 50px"
          @click="getDate(search.findSourceCode)">全部询价单</el-link>
        <el-link type="success" style="margin: 10px 20px" @click="getOne()">未报价</el-link>
        <el-link type="warning" style="margin: 10px 20px" @click="getTwo()">已报价</el-link>
        <el-link type="danger" style="margin: 10px 20px" @click="getThree()">已下单</el-link>
      </el-row>
      <el-table ref="table" :data="tableData" size="small" style="width: 100%; margin-top: 20px">
        <el-table-column prop="findSourceCode" label="寻源询价单号" align="center" />
        <el-table-column prop="createUsername" label="创建人" width="200" align="center" />
        <el-table-column prop="inventoryId" label="清单编码" width="200" align="center" />
        <el-table-column prop="checkStatus" label="状态" width="200" align="center">
          <template slot-scope="scope">
            <div>
              <el-tag v-if="scope.row.checkStatus === 0" :type="''">未报价</el-tag>
              <el-tag v-else-if="scope.row.checkStatus === 1" :type="''">已报价</el-tag>
              <el-tag v-else-if="scope.row.checkStatus === 2" :type="''">已下单</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center">
        </el-table-column>

        <el-table-column label="操作" width="265px" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="detail(scope.row)">
              询价详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="width: 80%; margin: 40px auto 40px; padding-left: 25%" background
        layout="total,prev, pager, next" @current-change="pageChange" :total="total">
      </el-pagination>
    </el-row>
  </div>
</template>
<script>
import { getUserInfo } from "@/api/login.js";
import { mapGetters } from "vuex";
import headerTop from "@/components/base/headerTop.vue";
import { getFindSourcePricePage } from "@/api/noticedetail.js";

export default {
  name: "notice",
  components: { headerTop },
  data() {
    return {
      bpmUserId: null,
      listQuery: {
        uid: null,
      },
      search: {
        findSourceCode: null,
      },
      projectQuery: {
        code: null,
        size: 10,
        page: 1,
        userId: null,
        userName: null,
        findSourceCode: null,
        keyword: null,
      },
      tableData: [],
      total: null,
      checkStatus: null,
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  created() {
    this.getUserInfo();
  },
  methods: {
    detail(data) {
      this.$router.push({ name: "historyDetail", query: { id: data.id } });
    },

    pageChange(e) {
      this.getDate(this.search.findSourceCode, e, this.checkStatus);
    },
    // 获取用户信息
    async getUserInfo() {
      this.loading = true;
      var res = await getUserInfo();
      if (res.status === 200) {
        this.projectQuery.userId = res.data.uid;
        this.getDate(this.search.findSourceCode);
      } else {
        this.$message.warning(res.msg);
      }
    },
    getOne() {
      this.checkStatus = 0;
      this.getDate(this.search.findSourceCode, 1, this.checkStatus);
    },
    getTwo() {
      this.checkStatus = 1;
      this.getDate(this.search.findSourceCode, 1, this.checkStatus);
    },
    getThree() {
      this.checkStatus = 2;
      this.getDate(this.search.findSourceCode, 1, this.checkStatus);
    },
    getDate(findSourceCode, page = 1, checkStatus) {
      this.projectQuery.page = page;
      this.projectQuery.findSourceCode = findSourceCode;
      this.projectQuery.checkStatus = checkStatus;
      this.projectQuery.inventoryId = this.$route.query.id;
      getFindSourcePricePage(this.projectQuery).then((res) => {
        this.tableData = res.content;
        this.total = res.totalElements;
      });
    },
    // 搜索
    searchKey() {
      this.getDate(this.search.findSourceCode);
    },
  },
};
</script>
<style lang="scss" scoped>
.notice {
  max-width: 1400px;
  line-height: 56px;
  margin: 10px auto;
  position: relative;
}

.bread1 {
  height: 56px;
  display: inline-block;
  cursor: default;

  span {
    margin: 5px;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
  }

  .btnAfter1 {
    cursor: pointer;
  }

  .btnAfter1:hover {
    color: #409eff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/goodHistory/index.vue